import { SHOW_HEADER, HIDE_HEADER } from '@/store/mutation-types'

export default {
  state: {
    isHidden: false
  },
  mutations: {
    [SHOW_HEADER] (state) {
      state.isHidden = false
    },
    [HIDE_HEADER] (state) {
      state.isHidden = true
    }
  },
  actions: {
    showHeader ({ state, commit }) {
      if (state.isHidden) {
        commit(SHOW_HEADER)
      }
    },
    hideHeader ({ state, commit }) {
      if (!state.isHidden) {
        commit(HIDE_HEADER)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/landing-header.js